export default __webpack_public_path__ + "static/media/face-verification.7f194c1a.svg";